import styled from 'styled-components';
import { Paragraph } from '@swordhealth/ui-corporate';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 546px;
  overflow: visible;
  width: 50%;
  z-index: 5;
  align-items: start;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    gap: 16px;
    margin: 0 auto;
    max-width: unset;
    width: 100%;
  }
`;

export const Subtitle = styled(Paragraph)`
  align-content: center;
  font-size: 16px;
  line-height: 28px;
`;

export const UpperLabel = styled(Paragraph)`
  width: fit-content;
  background-color: var(--ui-colors-neutral-300);
  border-radius: var(--ui-border-radius-full);
  color: var(--ui-colors-grey-700);
  font-size: 12px;
  line-height: 20px;
  font-family: var(--ui-font-family-heading);
  font-weight: var(--ui-font-weight-heading-bold);
  letter-spacing: 2px;
  padding: 6px 16px;
  text-align: center;
  text-transform: uppercase;
`;

export const ExtraLabel = styled(Subtitle)`
  color: #747986;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  max-width: 280px;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    max-width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  column-gap: 32px;
  row-gap: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoints.max_md}px) {
    flex-direction: column;
    gap: 12px;
  }
`;
